// actions
import * as A from '../actions/states-actions';

const initialState = {
  states: [],
  statesLoading: false,
  statesLoaded: false,
};

export default {
  states(state = initialState, action) {
    switch (action.type) {
      case A.getAllStates.type:
        return {
          ...state,
          statesLoading: true,
        };

      case A.getAllStates.success:
        return {
          ...state,
          states: action.payload.sort((a, b) => {
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1;
            }
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1;
            }
            return 0;
          }),
          statesLoading: false,
          statesLoaded: true,
        };

      case A.getAllStates.failure:
        return { ...state, statesLoading: false };

      case A.clearState.type:
        return initialState;

      default:
        return state;
    }
  },
};
